module.exports = __webpack_public_path__ + "static/img/wxxfc.b0a5b37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/wxxfc.jpg
// module id = eHK2
// module chunks = 21